export const JOB_STATUS = {
  PENDING: 'pending',
  DELIVERED: 'delivered',
  EVALUATED: 'evaluated',
};
